class ChainCustomizer extends CustomizerBase {
  constructor() {
    super();
    this.config = window.customizer.chain.config;
    this.slotPositions = window.customizer.chain.slots.map((slot, i) => {
      if (i + 1 > this.bundleQty * 1) slot.disabled = true;
      return slot;
    });

    this.bundleQtyPicker = this.querySelector('select.js-bundle-qty');
    this.bundleQtyPicker.value = this.bundleQty;

  }

  connectedCallback() {
    super.connectedCallback();
    this.toggleSubmitButton();
  }

  get bundleItems() {
    return this.data.bundleItems || [];
  }

  updateBundleData({ index, handle, variantId, src }) {
    this.data.bundleItems = this.data.bundleItems || [];
    this.data.bundleItems[index] = { variantId, handle, src };
    this.dataSave();
    this.toggleSubmitButton();
  }
  
  removeBundleItem(index) {
    console.log('remove', index);
    
    this.data.bundleItems = this.data.bundleItems || [];
    this.data.bundleItems[index] = null;
    this.querySelector(`.js-bundling-item[data-index="${index}"] .bundling-product--summary`).innerHTML = '';
    this.dataSave();
    this.toggleSubmitButton();
    this.render();
  }

  toggleSubmitButton() {
    const validItems = this.bundleItems
      .slice(0, this.bundleQty)
      .filter(item => item && item.variantId); // You can tighten this check if needed
  
    const allItemsPresent = validItems.length === this.bundleQty;
  
    this.toggleSubmitState({ disabled: !allItemsPresent });
  }
  

  get bundleQty() {
    return this.data.bundleQty || 3;
  }

  set bundleQty(qty) {
    this.data.bundleQty = qty;
    this.dataSave();
  }

  async init() {
    await super.init();
    this.render();
    this.initControls();
  }

  async refreshCanvas() {
    await super.refreshCanvas();
  }

  initControls() {
    super.initControls();
    this.displayBundleProducts();
    this.selectBundleProducts();
    this.displayAccordions();
    if (Accordion) {
      this.querySelectorAll('.accordion details').forEach((el) => {
        new Accordion(el);
      });
    }
  }

  selectBundleProducts() {
    this.stopAnimations = true;
    this.bundleItems.forEach((item, index) => {
      if (item && item.handle) {
        const color = this.variantColor.replaceAll('-', '_');
        this.querySelector(`.js-bundling-product[data-index="${index}"][data-handle="${item.handle}"][data-color="${color}"]`)?.click();
      }
    });
    this.stopAnimations = false;
  }
  deselectBundleProducts() {
    this.querySelectorAll('.bundling-product--summary').forEach((item) => (item.innerHTML = ''));
  }

  displayAccordions() {
    this.querySelectorAll('.js-bundling-item').forEach((item, i) =>
      i + 1 > this.bundleQty ? (item.style.display = 'none') : (item.style.display = 'block')
    );
  }
  displayBundleProducts() {
    this.querySelectorAll('.js-bundling-product').forEach((product, i) => {
      const color = product.dataset.color.replaceAll('_', '-');
      product.classList.remove('is-visible');
      if (color === this.variantColor) product.classList.add('is-visible');
    });
  }

  bundleQtyHandler(e) {
    this.bundleQty = e.target.value * 1;
    this.slotPositions.forEach((item, index) => {
      this.slotPositions[index].disabled = false;
      if (index + 1 > this.bundleQty) {
        this.removeBundleItem(index);
        this.slotPositions[index].disabled = true;
      }
    });
    this.render();
    this.displayAccordions();
  }

  addEvents() {
    super.addEvents();

    

    // Bundling:
    this.querySelectorAll('.js-bundling-product').forEach((bundleItem) => {
      bundleItem.addEventListener('click', (e) => {
        // Controls update
        const accordion = bundleItem.closest('.customizer-accordion');
        const bundleItemSummary = accordion.querySelector('.bundling-product--summary');
        const handle = bundleItem.dataset.handle;
        const variantId = bundleItem.dataset.variantId;
        const image = bundleItem.querySelector('img');
        const index = bundleItem.dataset.index;
        // Close accordion
        if (!this.stopAnimations) {
          accordion.querySelector('summary').click();
          accordion.nextElementSibling?.querySelector('details')?.setAttribute('open', '');
        }
        // Render accordion summary
        bundleItemSummary.innerHTML = bundleItem.innerHTML;

        // Bundle update
        this.updateBundleData({ index, handle, variantId, src: image.src });
        this.render();
      });
    });

    this.bundleQtyPicker.addEventListener('change', this.bundleQtyHandler.bind(this));

    this.querySelectorAll('.js-bundle-item-remove').forEach((bundleItemRemoval) => {
      bundleItemRemoval.addEventListener('click', (e) => {
        e.stopPropagation();
        this.removeBundleItem(bundleItemRemoval.dataset.index * 1);
      });
    })

  }

  variantChangeCallBack() {
    super.variantChangeCallBack();
    this.displayBundleProducts();
    this.deselectBundleProducts();
    this.selectBundleProducts();
    this.dataSave();
    this.render();
  }

  async render() {
    this.refreshCanvas();
    for (let index = 0; index < this.slotPositions.length; index++) {
      const slot = this.slotPositions[index];
      if (slot.disabled) continue;

      const bundleItem = this.bundleItems.find((item, i) => item && i == index && item.variantId);

      const container = new this.pixi.Container({
        x: slot.x,
        y: slot.y,
        zIndex: 3,
      });

      if (bundleItem) {
        const texturePromise = this.pixi.Assets.load(bundleItem.src);
        texturePromise.then((texture) => {
          const image = this.pixi.Sprite.from(bundleItem.src);
          const ratio = texture.orig.height / texture.orig.width;
          image.anchor.set(0.5);           
          image.width = this.config.pendant.width;
          image.height = image.width * ratio;
          image.angle = slot.angle;
          if (slot.flipX) {
            image.scale.x *= -1;
          }
          container.addChild(image);
        });
      } else if (!this.isSavingImage) {
        // Place default circle with index
        const text = new this.pixi.Text({
          text: index + 1,
          style: {
            fontFamily: 'RagSans',
            fontSize: 24,
            fontWeight: '500',
            align: 'center',
          },
          x: -5,
          y: -7,
        });
        const circle = new this.pixi.Graphics().circle(0, 0, 25).fill('rgba(251, 247, 242, 1)');
        container.addChild(circle);
        container.addChild(text);
      }

      this.app.stage.addChild(container);
    }
  }
  async cartPrepare() {
    await super.cartPrepare();

    this.cartAppend(`properties[_bundle_role]`, 'parent');
    this.bundleItems.forEach((bundleItem, index) => {
      if (bundleItem !== null) {
        let variantId = bundleItem.variantId;
        // item variantId:
        this.cartAppend(`items[${index}][id]`, variantId);
        this.cartAppend(`items[${index}][properties[As part of]]`, this.dataset.title);
        this.cartAppend(`items[${index}][properties[Bundle Position]]`, index + 1);
        this.cartAppend(`items[${index}][properties[_customization_id]]`, this.id);
        this.cartAppend(`items[${index}][properties[_bundle_role]]`, 'child');
        this.cartAppend(`items[${index}][properties[_parent_variant_id]]`, variantId);
        this.cartAppend(`items[${index}][properties[_src]]`, bundleItem.src);
        // item qty:
        this.cartAppend(`items[${index}][quantity]`, 1);
        // props:
        this.cartAppend(`properties[_appended_variant_${index + 1}]`, variantId);
      }
    });
  }
}

customElements.define('chain-customizer', ChainCustomizer);
